import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';

export const SupplementsSection = ({ t }) => {
  return (
    <section id="supplements" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            {t.supplements.title}
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            {t.supplements.description}
          </p>
        </div>

        {/* Supplements Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {t.supplements.items.map((item, index) => (
            <Card 
              key={index} 
              data-testid={`supplement-product-${index}`}
              className="group hover:shadow-2xl transition-all duration-300 border-2 border-slate-200 hover:border-slate-700 overflow-hidden"
            >
              {/* Product Image */}
              {item.image && (
                <div className="flex items-center justify-center p-6 h-72 overflow-hidden relative">
                  <img src="https://customer-assets.emergentagent.com/job_67b366a2-9c46-4ca8-9e2f-e7e30db89ded/artifacts/sb4uob6v_Dise%C3%B1o%20sin%20t%C3%ADtulo%20%2821%29.png" alt="" className="absolute inset-0 w-full h-full object-cover" />
                  <img 
                    src={item.image} 
                    alt={item.name}
                    className="relative h-full w-auto object-contain group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
              )}
              <CardHeader className="pt-4 pb-2">
                <CardTitle className="text-xl text-slate-900">{item.name}</CardTitle>
                {item.subtitle && (
                  <Badge className="w-fit bg-slate-800 text-white">{item.subtitle}</Badge>
                )}
                <CardDescription className="text-sm pt-2 text-slate-600">{item.description}</CardDescription>
                {item.presentation && (
                  <p className="text-xs text-slate-500 font-medium mt-1">{item.presentation}</p>
                )}
              </CardHeader>
              <CardContent>
                <div className="space-y-2">
                  <p className="text-xs font-semibold text-slate-700 mb-2 uppercase tracking-wide">Beneficios:</p>
                  {item.benefits.map((benefit, idx) => (
                    <div key={idx} className="flex items-start space-x-2">
                      <CheckCircle2 className="w-4 h-4 text-slate-700 flex-shrink-0 mt-0.5" />
                      <span className="text-sm text-slate-600">{benefit}</span>
                    </div>
                  ))}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};
